import { GetReferralSettingModel } from "@factory/model/query-model-referral-setting";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { referralSettingFormDefault } from "./form.default";
import { ReferralSettingFormSchema } from "./form.rule";

export const useFormDefaultReferralSetting = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetReferralSettingModel | undefined) => {
    return !cachedValue
      ? referralSettingFormDefault
     : ({
        tenant: cachedValue.tenant,
        points: cachedValue.points,
        stamp: cachedValue.stamp,
        referralType: cachedValue.referral_type,
      } as ReferralSettingFormSchema);
  };

  return {
    getDefault,
  };
};
